import { render, staticRenderFns } from "./DeveloperContact.vue?vue&type=template&id=ac1fced6&scoped=true&"
import script from "./DeveloperContact.vue?vue&type=script&lang=js&"
export * from "./DeveloperContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1fced6",
  null
  
)

export default component.exports